// src/app/auth/auth.service.ts

import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { mergeMap } from 'rxjs/operators';
import * as auth0 from 'auth0-js';
import { AUTH_CONFIG } from '../auth/auth.config';

import { timer, of } from 'rxjs';
import { UsersService } from '../services/users.service';
import { UserDTO } from '../../harvest-engine/core/models/user';
import { TenantWordService } from '../../harvest-engine/core/services/TenantWord.service';
import { SignalrIntegrationsHubService } from '../../harvest-engine/core/signalr/signalr-integrations-hub.service';
import { environment } from '../../../environments/environment';
declare var localStorage: Storage;

(window as any).global = window;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  
  isAdmin: boolean;
  isGettingUser: boolean = false;
  // define the refreshSubscription property
  refreshSubscription: any;
  clientId: any;
  


  auth0: any;

  constructor(public router: Router,
    private injector: Injector,
  ) { 
    // get subdomain from the url
    const subdomain = window.location.hostname.split('.')[0];

    var clientId = AUTH_CONFIG.CLIENT_ID;
    this.clientId = clientId;
    var clientDomain = AUTH_CONFIG.CLIENT_DOMAIN;

    // if the subdomain exists, set the clientId and domain
    if (subdomain && subdomain.toLowerCase() == 'vgf' || environment.isVGF) {
      clientId = 'LsmsMTFhLgiefCBuW3dKpXqEtlmPMvfA';
      this.clientId = clientId;
      clientDomain = 'vgf.us.auth0.com';
    }


    this.auth0 = new auth0.WebAuth({
      clientID: clientId,
      domain: clientDomain,
      responseType: 'token id_token code',
      audience: 'https://hub.krag.works',
      redirectUri: this.getCallbackURL(),
      scope: AUTH_CONFIG.SCOPE,
      algorithms: ['RS256'],
      
    });
  }

  public login(): void {
    this.auth0.authorize();
  }

  public handleAuthentication(): void {

    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {

        this.setSession(authResult);

        // Both calls only need the access token already written above by setSession(),
        // so run them in parallel instead of chaining - saves a full network round trip on login.
        const profilePromise = this.retrieveProfile(authResult).then(result => {
          this.setProfile(result);
        });

        const userPromise = new Promise<void>(resolve => {
          this.SetKragworksUser(() => resolve());
        });

        Promise.all([profilePromise, userPromise]).then(() => {
          this.reportLogin();
          this.router.navigate(['/']);
        });

        this.SetDictionary();

        return;

      } else if (err) {
        console.error(err)
        this.router.navigate(['/login']);
      } else {
        this.router.navigate(['/login']);
      }

    });
  }

  public handlePortalTransfer(): Promise<boolean> {
    // This is called when tokens are received from old portal
    // We need to retrieve the user profile using the tokens we just set
    // Returns a Promise that resolves when user data is fully loaded

    return new Promise((resolve, reject) => {
      const accessToken = localStorage.getItem('access_token');

      if (!accessToken) {
        console.error('No access token found for portal transfer');
        this.router.navigate(['/login']);
        resolve(false);
        return;
      }

      console.log('Processing portal transfer with existing tokens');

      // Use the access token to get user info
      this.auth0.client.userInfo(accessToken, (err, profile) => {
        if (profile) {
          console.log('Successfully retrieved user profile from portal transfer');
          localStorage.setItem('authProfile', JSON.stringify(profile));
          this.isAdmin = this._checkAdmin(profile);

          // Get Kragworks user data - resolve Promise when complete
          this.SetKragworksUser(() => {
            console.log('Portal transfer complete, user data loaded');
            this.reportLogin();
            // Schedule token renewal
            this.scheduleRenewal();
            // Resolve the promise - user data is now ready
            resolve(true);
          });

          // Set dictionary (can run in parallel)
          this.SetDictionary();

        } else if (err) {
          console.error('Error retrieving user profile during portal transfer:', err);
          this.router.navigate(['/login']);
          resolve(false);
        }
      });
    });
  }

  private setSession(authResult): void {

    // Set the time that the Access Token will expire at
    const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);

    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    this.scheduleRenewal();
  }

  public setToken(token: string){
    localStorage.setItem('access_token', token);
  }

  retrieveProfile(authResult) {

    return new Promise((resolve, reject) => {
      this.auth0.client.userInfo(authResult.accessToken, (err, profile) => {
        if (profile) {
          resolve(profile);
        } else if (err) {
          reject(err);
        }
      });
    });
  }

  private setProfile(profile): void {
    localStorage.setItem('authProfile', JSON.stringify(profile));
    this.isAdmin = this._checkAdmin(profile);

  }

  public userProfile(): any {
    const profile = JSON.parse(localStorage.getItem('userProfile'));

    
    if (profile === null || profile === undefined) {
      return;
    }

    if (profile.picture === null || profile.picture === undefined || profile.picture === '') {
      profile.picture = 'assets/images/favicon.png';
    }

    return profile;
  }

  public authProfile(): any {
    const profile = JSON.parse(localStorage.getItem('authProfile'));

    if (profile == null || profile === undefined) {
      this.SetKragworksUser(() => { });
    }
    return profile;
  }

  public logout(): void {
    // Remove tokens and expiry time from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('authProfile');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('growerRecs_dateFilter');
    // Clear cached filter state so filters don't leak across users/tenants on re-login
    localStorage.removeItem('kw_filter_state');
    localStorage.removeItem('kw_retain_filters_checked');
    this.unscheduleRenewal();

    this.auth0.logout({
      returnTo: this.getCallbackURL(),
      clientID: this.clientId,
    });
    // Go back to the home route
    this.router.navigate(['login']);

  }

  public isAuthenticated(): boolean {
    // Check whether the current time is past the
    // Access Token's expiry time

    const expiresAt = JSON.parse(localStorage.getItem('expires_at') || '{}');
    var result = new Date().getTime() < expiresAt;

    return result;
  }


  public getTenantId(): string {
    return this.authProfile()['https://kragworks:auth0:com/tenant_id'];
  }

  public getUserToken(): string {
    if (this.isAuthenticated()) {
      return 'Bearer '.concat(localStorage.getItem('access_token'));
    } else { return ''; }

  }

  public renewToken() {
    this.auth0.checkSession({}, (err, result) => {
      if (err) {
        console.error('Error renewing token:', err);
      } else {
        this.setSession(result);
      }
    });
  }

  private _checkAdmin(profile) {
    // Check if the user has admin role
    const roles = profile[AUTH_CONFIG.NAMESPACE] || [];
    return roles.indexOf('admin') > -1;
  }


  public scheduleRenewal() {
    if (!this.isAuthenticated()) { return; }
    this.unscheduleRenewal();

    const expiresAt = JSON.parse(window.localStorage.getItem('expires_at'));

    const expiresIn$ = of(expiresAt).pipe(
      mergeMap(
        // tslint:disable-next-line:no-shadowed-variable
        expiresAt => {
          const now = Date.now();
          // Use timer to track delay until expiration
          // to run the refresh at the proper time
          return timer(Math.max(1, expiresAt - now));
        }
      )
    );

    // Once the delay time from above is
    // reached, get a new JWT and schedule
    // additional refreshes
    this.refreshSubscription = expiresIn$.subscribe(
      () => {
        this.renewToken();
        this.scheduleRenewal();
      }
    );
  }

  public unscheduleRenewal() {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }

  // User Methods
  public SetKragworksUser(callback: (data) => void) {
    if (!this.isGettingUser) {
      this.isGettingUser = true;
      this.injector.get(UsersService).apiUsersGetCurrentUserGet().subscribe({next:user => {

        //TODO: SET DICTIONARY
        this.isGettingUser = false;
        localStorage.setItem('userProfile', JSON.stringify(user));
        callback(user);
      }, error:err => console.log(err)});
    }
  }

  /** Tells KragworksHub a fresh sign-in just happened (usage metrics). Best-effort: never blocks or fails login. */
  private reportLogin(): void {
    try {
      this.injector.get(HttpClient)
        .post(`${environment.PLATFORM_API_URL}/api/usage-metrics/login`, { client: 'web' })
        .subscribe({ error: () => { /* metrics only */ } });
    } catch (e) {
      // metrics only
    }
  }

  public SetDictionary() {
    localStorage.removeItem('tenantWordDictionary');
    // this.injector.get(TenantWordService).setToken(this.getUserToken());
    this.injector.get(TenantWordService).getTenantWords().subscribe(words => {
      localStorage.setItem('tenantWordDictionary', JSON.stringify(words));
    });
  }

  public getCurrentUser(): UserDTO {

    return JSON.parse(localStorage.getItem('userProfile'));
  }

  // get callback
  private getCallbackURL(): string {
    let callback: string;

    const domain = window.location.hostname;

    if (domain.indexOf('.') < 0 ||
      domain.split('.')[0] === 'example' || domain.split('.')[0] === 'lvh' || domain.split('.')[0] === 'www') {
      callback = AUTH_CONFIG.REDIRECT;
    } else {


      callback = "https://" + domain + "/callback";
    }
    return callback;
  }


  public hasRole(expectedRole: string): boolean {
    let result: boolean = false;

    // iterate through all expected roles and see if user has them.
    if (this.userProfile().roles.some(role => role.name == expectedRole || role.name == 'kw:admin')) {
      result = true;
    }

    return result;
  }

  public hasTenant(expectedTenants: string[]): boolean {
    let result: boolean = false;

    // iterate through all expected roles and see if user has them.
    if (expectedTenants.some(x => x == this.userProfile().tenant.name) || this.hasRole('kw:admin')) {
      result = true;
    }

    return result;
  }

}
